<template>
    <v-container  fill-height fluid class="grey lighten-4">
        <verification v-if="waitForLogin"/>
        <v-row v-else align="center" justify="center" class="mb-15 pb-15">
            <v-col class="text-center" cols="10" sm="6" md="3" style="max-width: 360px">
                <img width="200" src="../../assets/oeskb.png" class="mb-10" >
                <div v-if="!firebaseActionExpired">
                    <p class="font-weight-bold pb-1">Passwort für die ÖSKB App ändern</p>
                    <p class="pb-1">Bitte gib das neue Passwort für '<span class="primary--text">{{$route.query.email}}</span>' ein:</p>
                    <v-form ref="form" lazy-validation v-if="rules" @submit.prevent>
                        <v-text-field v-model="password" label="Passwort"
                                      :append-icon="showPW ? 'mdi-eye' : 'mdi-eye-off'"
                                      :type="showPW ? 'text' : 'password'"
                                      :rules="[rules.required, rules.password.min]"
                                      @click:append="showPW = !showPW"
                                      outlined dense clearable></v-text-field>
                        <error-msg :error="errorMsg"></error-msg>
                        <v-btn depressed block color="primary" @click="login()">Speichern und anmelden</v-btn>
                    </v-form>
                </div>
                <div v-else>
                    <p class="font-weight-bold pb-1">Passwort für die ÖSKB App zurücksetzen</p>
                    <p class="pb-1">Diese Aktion ist leider abgelaufen, bitte klicke auf den Button um sie erneut zu starten!</p>
                    <v-btn depressed block color="primary" @click="navigateReset()">Neu starten</v-btn>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {FormRules} from "../../services/formRules";
    import Verification from "./verification";
    import firebase from 'firebase/app'
    import 'firebase/auth'
    import ErrorMsg from "../../components/elements/errorMsg";
    import { db } from '../../services/db'

    export default {
        components: {
            ErrorMsg,
            Verification},
        name: "forgot-password",
        computed: {
            user(){ return this.$store.state.user }
        },
        data: () => ({
            waitForLogin: false,
            password: '',
            showPW: false,
            rules: null,
            errorMsg: '',
            firebaseActionExpired: false,
        }),
        created(){
            this.rules = new FormRules();
            this.code = this.$route.query.oobCode;
            firebase.auth().verifyPasswordResetCode(this.code)
                .then()
                .catch((error) => {
                    console.log ("error", error);
                    if ( error.code === 'auth/expired-action-code' || error.code === 'auth/invalid-action-code' ) {
                        this.firebaseActionExpired = true;
                        //http://localhost:8080/#/?method=resetPW
                    } else {
                        this.errorMsg = error;
                    }
                })
        },
        methods: {
            login() {
                if( !this.$refs.form.validate() ) { return }
                this.waitForLogin = true;
                firebase.auth().confirmPasswordReset(this.code, this.password)
                    .then(() => {
                        firebase.auth().setPersistence(firebase.auth.Auth.Persistence[this.$store.state.config.persistence])
                            .then(() => {
                                firebase.auth().signInWithEmailAndPassword(this.$route.query.email, this.password)
                                    .then((user) => {
                                        console.log ("user: ", user);
                                        this.$router.push({ path: '/Ergebnisdienst'});
                                        this.waitForLogin = false;
                                        this.clearUserPending(user.user);
                                    })
                                    .catch((error) => {
                                        this.waitForLogin = false;
                                        this.loginError(error);
                                    });
                                this.waitForLogin = false;
                            })
                            .catch((error) => {
                                this.waitForLogin = false;
                                this.loginError(error);
                            });
                    })
                    .catch((error) => {
                        this.waitForLogin = false;
                        this.loginError(error);
                    });
            },
                clearUserPending(user){
                    console.log ("clearUserPending", user);
                    const docRef = db.collection('users_pending');
                    docRef.doc(user.uid).delete().then(() => {
                        console.log("Document successfully deleted!");
                    }).catch((error) => {
                        console.error("Error removing document: ", error);
                    });
                },
            loginError(error) {
                console.log ("errorCode: ", error.message);
                let errMessage = "";
                switch (error.code) {
                    case 'auth/invalid-email':
                        errMessage = 'Bitte gültige E-Mail-Adresse eingeben!'; break;
                    case 'auth/user-not-found':
                        errMessage = 'Zu dieser E-Mail-Adresse gibt es kein Konto.'; break;
                    case 'auth/wrong-password':
                        errMessage = 'Das Passwort ist falsch!'; break;
                    case 'auth/too-many-requests':
                        errMessage = 'Der Zugriff auf dieses Konto wurde aufgrund zahlreicher fehlgeschlagener ' +
                            'Anmeldeversuche vorübergehend deaktiviert. Du kannst es wiederherstellen, ' +
                            'indem du dein Passwort zurücksetzt, oder du kannst es später erneut versuchen.';
                        break;
                    default:
                        console.log ("errorCode: ", error.code);
                        this.errorMsg = error.message;
                        return
                }
                this.errorMsg = errMessage;
            },
            navigateReset() { // navigate to subscreen
                this.$router.push({ path: '/', query: {action: 'resetPW'}});
            },
        },
    }
</script>

<style scoped>
    .no-uppercase { text-transform: none; }
</style>